import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from './api.service';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { AuthRedirectGuard } from './shared/services/auth-redirect.guard';
import {
  AUTH_SILENT_ATTEMPTED_KEY,
  clearAuthSessionFlags,
  clearAuth0Cache,
  clearStoredAuthTokens,
  isJwtExpired,
} from './shared/services/token.util';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Auth0 Angular SDK Sample';
  datas: any;
  accessTokenData = '';
  userInfo: any;
  role: any;
  // emailId: string;
  idToken: any;
  accessToken: any;

  authSub?: Subscription;
  userSub?: Subscription;
  tokenSub?: Subscription;

  constructor(
    private service: ApiService,
    public auth: AuthService,
    private router: Router,
    private authRedirectGuard: AuthRedirectGuard
  ) {
    console.log('Trying Authentication');
    // this.initializeAuthentication();
  }

  // initializeAuthentication(): void {
  //   this.authSub = this.auth.isAuthenticated$.pipe(take(1)).subscribe({
  //     next: (isAuthenticated) => {
  //       console.log('isAuthenticated:', isAuthenticated);

  //       if (isAuthenticated) {
  //         clearAuthSessionFlags();
  //         this.loadUserAndToken();
  //         return;
  //       }

  //       if (sessionStorage.getItem(AUTH_SILENT_ATTEMPTED_KEY) === '1') {
  //         // Silent SSO already failed — stay on home; user clicks Log in
  //         return;
  //       }

  //       console.log('Checking SSO session...');
  //       sessionStorage.setItem(AUTH_SILENT_ATTEMPTED_KEY, '1');

  //       // Silent SSO restore when already logged in on the other panel (e.g. :4200)
  //       this.auth.loginWithRedirect({
  //         authorizationParams: {
  //           prompt: 'none',
  //         },
  //         appState: {
  //           target: window.location.pathname || '/',
  //         },
  //       });
  //     },
  //     error: (err) => {
  //       console.error('Auth Error:', err);
  //     },
  //   });
  // }

  // loadUserAndToken(): void {
  //   this.tokenSub = this.auth.getAccessTokenSilently().subscribe({
  //     next: (token) => {
  //       console.log('Access Token:', token);

  //       if (isJwtExpired(token)) {
  //         clearStoredAuthTokens();
  //         this.authRedirectGuard.redirectForTokenError({
  //           error: 'login_required',
  //           message: 'Access token expired',
  //         });
  //         return;
  //       }

  //       this.accessTokenData = token;
  //       localStorage.setItem('accessToken', token);

  //       this.auth.idTokenClaims$
  //         .pipe(take(1), filter((claims) => !!claims))
  //         .subscribe((claims: { __raw?: string }) => {
  //           if (claims.__raw && !isJwtExpired(claims.__raw)) {
  //             localStorage.setItem('idToken', claims.__raw);
  //           }
  //         });

  //       this.loadUser();
  //     },
  //     error: (error) => {
  //       console.error('Token Error:', error);

  //       const message = error?.message ?? '';
  //       const isMissingRefreshToken =
  //         message.includes('Missing Refresh Token') ||
  //         error?.error === 'missing_refresh_token';

  //       clearStoredAuthTokens();
  //       clearAuth0Cache();

  //       if (isMissingRefreshToken) {
  //         clearAuthSessionFlags();
  //         this.auth.loginWithRedirect({
  //           appState: { target: window.location.pathname || '/' },
  //         });
  //         return;
  //       }

  //       this.authRedirectGuard.redirectForTokenError(error);
  //     },
  //   });
  // }

  // loadUser(): void {
  //   this.userSub = this.auth.user$.pipe(take(1)).subscribe((user: any) => {
  //     console.log('Auth0 User:', user);

  //     const username = user?.username ?? user?.email;
  //     if (username && !this.userInfo) {
  //       this.getUser(username);
  //     }
  //   });
  // }

  ngOnInit(): void {

    this.auth.isLoading$
      .pipe(
        filter((loading) => !loading),
        take(1),

        switchMap(() =>
          this.auth.isAuthenticated$.pipe(take(1))
        ),

        switchMap((isAuthenticated) => {
          if (!isAuthenticated) {
            this.auth.loginWithRedirect({
              appState: {
                target: window.location.pathname
              }
            });
            return EMPTY;
          }
          return this.auth.getAccessTokenSilently({
            authorizationParams: {
              audience: environment.auth.authorizationParams.audience,
            }
          });
        }),

        tap((accessToken) => {

          if (!accessToken) {
            return;
          }

          this.accessToken = accessToken;

          console.log('Access Token', accessToken);
        }),

        switchMap(() =>
          this.auth.idTokenClaims$.pipe(take(1))
        ),

        tap((claims: any) => {

          this.idToken = claims?.__raw || '';

          console.log('ID Token', this.idToken);
        }),

        switchMap(() =>
          this.auth.user$.pipe(take(1))
        ),

        switchMap((auth0User: any) => {

          const username =
            auth0User?.username ||
            auth0User?.nickname ||
            auth0User?.email;

          if (!username) {
            return EMPTY;
          }

          return this.service.getUserInfo(username);
        }),

        catchError((error) => {

          console.error('Auth Flow Error', error);

          return EMPTY;
        })
      )
      .subscribe({
      next: (res) => {
        this.datas = res;
        this.userInfo = this.datas?.data?.[0];

        if (!this.userInfo) {
          return;
        }

        this.role = this.userInfo?.role_name;
        console.log(this.userInfo, this.role);

        localStorage.setItem('userInfo', this.userInfo._id);
        localStorage.setItem('role', this.role);

        if (this.role == 'Admin') {
          console.log('admin', this.userInfo._id);
          localStorage.setItem('adminInfo', this.userInfo._id);
          this.router.navigate(['/admin']);
        } else if (this.role == 'Coordinator') {
          console.log('coordinator', this.userInfo._id);
          localStorage.setItem('coordinatorInfo', this.userInfo._id);
          this.router.navigate(['/coordinator']);
        } else if (this.role == 'Client') {
          console.log('client', this.userInfo._id);
          localStorage.setItem('clientInfo', this.userInfo._id);
          this.router.navigate(['/client']);
        } else if (this.role == 'Evaluator') {
          localStorage.setItem('evaluatorInfo', this.userInfo._id);
          this.router.navigate(['/evaluator']);
        } else if (this.role == 'Super-Admin') {
          localStorage.setItem('adminInfo', this.userInfo._id);
          this.router.navigate(['/super-admin']);
        } else if (this.role == 'Consultant') {
          localStorage.setItem('clientInfo', this.userInfo._id);
          this.router.navigate(['/client']);
        } else if (this.role == 'Auditor') {
          console.log('auditor', this.userInfo._id);
          localStorage.setItem('auditorInfo', this.userInfo._id);
          this.router.navigate(['/auditor']);
        }
      },
    });
  }


  // getUser(username: string): void {
  //   console.log(username);
  //   this.service.getUserInfo(username).subscribe({
  //     next: (res) => {
  //       this.datas = res;
  //       this.userInfo = this.datas?.data?.[0];

  //       if (!this.userInfo) {
  //         return;
  //       }

  //       this.role = this.userInfo?.role_name;
  //       console.log(this.userInfo, this.role);

  //       localStorage.setItem('userInfo', this.userInfo._id);
  //       localStorage.setItem('role', this.role);

  //       if (this.role == 'Admin') {
  //         console.log('admin', this.userInfo._id);
  //         localStorage.setItem('adminInfo', this.userInfo._id);
  //         this.router.navigate(['/admin']);
  //       } else if (this.role == 'Coordinator') {
  //         console.log('coordinator', this.userInfo._id);
  //         localStorage.setItem('coordinatorInfo', this.userInfo._id);
  //         this.router.navigate(['/coordinator']);
  //       } else if (this.role == 'Client') {
  //         console.log('client', this.userInfo._id);
  //         localStorage.setItem('clientInfo', this.userInfo._id);
  //         this.router.navigate(['/client']);
  //       } else if (this.role == 'Evaluator') {
  //         localStorage.setItem('evaluatorInfo', this.userInfo._id);
  //         this.router.navigate(['/evaluator']);
  //       } else if (this.role == 'Super-Admin') {
  //         localStorage.setItem('adminInfo', this.userInfo._id);
  //         this.router.navigate(['/super-admin']);
  //       } else if (this.role == 'Consultant') {
  //         localStorage.setItem('clientInfo', this.userInfo._id);
  //         this.router.navigate(['/client']);
  //       } else if (this.role == 'Auditor') {
  //         console.log('auditor', this.userInfo._id);
  //         localStorage.setItem('auditorInfo', this.userInfo._id);
  //         this.router.navigate(['/auditor']);
  //       }
  //     },
  //   });
  // }

  ngOnDestroy(): void {
    this.authSub?.unsubscribe();
    this.userSub?.unsubscribe();
    this.tokenSub?.unsubscribe();
  }
}
